
// region JS Imports

// region External Modules
import $ from "jquery"
import u from "umbrellajs"
import serialize from "form-serialize"

import I18n from "plugins/i18n-js"
// endregion External Modules

// Private Modules
import Modal from "app/modal/show-modal"
import Notifier from "app/notifier/index"
import Auth_action from "app/authentication/action"
import Auth_remote_state from "app/authentication/remote_state"
import shortlist from "app/listings/shortlist"

import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


const CELL_CLASS_NAME = "cell--listings--problems--reports--new-report--box"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`



const onSuccess = (data: string) => {
  // # HACK: get embed data attribute for listing_id in returned HTML
  const listing_id = $(data).find("[data-listing-id]").data("listing-id")
  const email = $(data).find("[data-email]").data("email")
  Modal.hideTopModal()
  Modal.showModalWithContent(data)
  Auth_remote_state.refreshAndUpdateComponentPromise()
  .then((signed_in) => {
    // # If signed in, already done in backend
    if (signed_in) { return }
    // # bugged?
    if (listing_id == null) { return }
    // # Try to shortlist the listing with AJAX,
    // # which actually queue the action and show sign up modal
    Auth_action.showSignInModal().done()
    // # Queue the sign up
    shortlist(listing_id, {
      show_auth_modal_on_fail: false,
    })
  })
}

const onError = (response: Response) => {
  if (response.status === 422){
    Notifier.showError(I18n.t("js.app.notifier.defaults.form_invalid"))
    Modal.hideTopModal()
    response.text().then((text) => Modal.showModalWithContent(text))
  }
  else{
    Notifier.showError(I18n.t("js.app.notifier.defaults.form_submit_failed"))
  }
}


const init = () => {
  u(`.${CELL_CLASS_NAME}`).each((el) => {
    const $el = $(el)

    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_INITIALIZED_CLASS_NAME)

    const $form = $el.find("form")
    const $problem_type_selector =
      $form.find(".cell--listings--problems--reports--new_report--box__listing-report-form--problem-type")

    $problem_type_selector.on("change", () => {
      if ($form.find(".cell--listings--problems--reports--new_report--box__listing-report-form--problem-type:checked").val() === "others"){
        $el.addClass("show--message--box")
      }
      else{
        $el.removeClass("show--message--box")
      }
    })

    $form.on("submit", (e) => {
      e.preventDefault()
      const selected_checkboxes = $form.find(".cell--listings--problems--reports--new_report--box__listing-report-form--problem-type:checked")
      if (selected_checkboxes.length === 0){
        Notifier.showError(I18n.t("js.app.notifier.listings.problems.reports.no_problem_type_selected"))
        return
      }

      q_ajax_3({
        url:      $form.attr("action"),
        method:   "POST",
        data:     serialize(($form[0] as HTMLFormElement), {hash: true}),
      })
      .then(({data}) => onSuccess(data))
      .catch(({response}) => onError(response))
    })

  })
}

export default {init}
